module.exports = __webpack_public_path__ + "static/sofia-004-028af122ce598b577254659268f43774.jpg";